export default __webpack_public_path__ + "static/media/why4.de557ce8.png";